var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnStrokeChevronDownHaseGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/stroke/chevron-down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M362.533009,144.393398 C368.390873,138.535534 377.888348,138.535534 383.746212,144.393398 C389.604076,150.251263 389.604076,159.748737 383.746212,165.606602 L383.746212,165.606602 L249.106,300.246 L383.746212,434.885822 C389.604076,440.743687 389.604076,450.241161 383.746212,456.099026 C377.888348,461.95689 368.390873,461.95689 362.533009,456.099026 L217.898449,311.464466 C217.170185,310.736202 216.532461,309.951684 215.985276,309.124899 C211.580656,303.249273 212.049655,294.876752 217.393398,289.533009 L217.393398,289.533009 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/stroke/chevron-down",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Colour",
    fill: "#34A344",
    transform: "translate(300.569805, 300.246212) rotate(-90.000000) translate(-300.569805, -300.246212) ",
    xlinkHref: "#path-1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStrokeChevronDownHaseGreen);
export default __webpack_public_path__ + "static/media/icn_stroke_chevron_down_hase_green.7e2bdd3fd252f698932a6a918aebd70e.svg";
export { ForwardRef as ReactComponent };